<template>
  <div>
    <div class="title" v-if="loginType === 'scan'">扫码登录</div>
    <div class="title" v-if="loginType === 'wx'">云滴管家微信授权登录</div>

    <div class="code-area">
      <div class="code-content">
        <vue-qr ref="qrCode" :text="qrCodeUrl" :size="228" :margin="0" v-if="qrCodeUrl" />
        <div v-if="showMask" class="code-mask">
          <div class="code-mask-tip">{{ maskTip }}</div>
          <el-button
            v-if="qrCodeTime === 0 || qrCodeTime < 0 || qrCodeStatus === 4"
            type="success"
            size="mini"
            :loading="refreshLoading"
            @click="getQrCode"
          >
            请点击刷新
          </el-button>
        </div>
      </div>
    </div>
    <div class="tip">
      <div>请使用</div>
      <el-button type="text" @click="goPage">云滴管家</el-button>
      <div>扫码登录</div>
    </div>
  </div>
</template>

<script >
import VueQr from 'vue-qr';
import store from '@/store';
import { ref, inject, watch, computed, onMounted, onBeforeUnmount } from '@vue/composition-api';
import { queryLoginQrCode, queryLoginQrCodeStatus } from '@/api/login';
import { useCountDown, useRouter } from '@/hooks';
import mqStore from '@/util/mqtt-engine';
import { initMap } from '@/plugins/plugins.amap.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    createConnect
  } = mqStore();
  const router = useRouter();
  const loginType = inject('loginType');
  const handleBind = inject('handleBind');
  const qrCodeUrl = ref('');
  // 二维码uuid
  const qrCodeId = ref('');
  // 二维码状态 1：正常 2：已扫描 3：已确认 4：取消
  const qrCodeStatus = ref(1);

  // 此计时器用户判断二维码是否失效
  const {
    time: qrCodeTime,
    start,
    end
  } = useCountDown();
  // 此计时器用于轮询二维码状态
  let reqST = null;
  const reqStart = callback => {
    reqEnd();
    reqST = setInterval(() => {
      callback && callback();
    }, 3000);
  };
  const reqEnd = () => {
    if (reqST) {
      clearInterval(reqST);
    }
  };
  onBeforeUnmount(() => {
    reqEnd();
  });

  // 二维码状态改变后显示遮罩层
  const maskTip = computed(() => {
    if (qrCodeTime.value === 0 || qrCodeTime.value < 0) {
      return '二维码已失效';
    }
    if (qrCodeStatus.value === 2) {
      return '用户已扫描';
    }
    if (qrCodeStatus.value === 3) {
      return '用户已确认';
    }
    if (qrCodeStatus.value === 4) {
      return '用户已取消';
    }
    return '';
  });
  const showMask = computed(() => {
    return maskTip.value !== '';
  });

  // 获取二维码数据
  const refreshLoading = ref(false);
  const getQrCode = async () => {
    refreshLoading.value = true;
    const res = await queryLoginQrCode();
    refreshLoading.value = false;
    const {
      code,
      data
    } = res || {};
    if (code !== 0) {
      return;
    }
    const urlObj = {
      ...data,
      type: 'login'
    };
    qrCodeUrl.value = JSON.stringify(urlObj);
    qrCodeId.value = data.uuid;
    qrCodeStatus.value = data.status;
    // 二维码失效-开始计时
    start(60);
    // 轮询二维码状态
    reqStart(getQrCodeStatus);
  };
  onMounted(() => {
    getQrCode();
  });
  const tagWel = computed(() => {
    return store.state.tags.tagWel;
  });

  // 查询二维码状态
  const getQrCodeStatus = async () => {
    const res = await queryLoginQrCodeStatus({
      uuid: qrCodeId.value
    });
    const {
      code,
      data
    } = res || {};
    if (code !== 0) {
      return;
    }
    const {
      status,
      token
    } = data || {};
    qrCodeStatus.value = status;

    // 用户已取消、用户已确认,关闭定时器
    if (status === 3 || status === 4) {
      end();
      reqEnd();
    }
    const {
      data: tokenData
    } = token || {};
    if (tokenData && tokenData.token) {
      // 设置token信息
      store.dispatch('SetLoginToken', tokenData);
      // 获取用户信息
      const res2 = await store.dispatch('GetUserInfo');
      const {
        code: code2
      } = res2 || {};
      if (code2 !== 0) {
        return;
      }
      // 进行openId和账号绑定
      if (loginType.value === 'wx') {
        handleBind();
      }
      initMap();
      // 跳转主页
      router.push({
        path: tagWel.value.value
      });

      // 订阅登录登出消息
      createConnect();
      store.dispatch('subScribeLogout', () => {
        router.push({
          path: '/login'
        });
      });
    }
  };
  watch(qrCodeTime, v => {
    // 二维码失效，关闭查询二维码状态定时器
    if (v === 0 || v < 0) {
      reqEnd();
    }
  }, {
    immediate: true
  });

  // 跳转云滴管家下载页面
  const goPage = () => {
    window.open('http://uni-admin.ayundi.cn/H5/download/oa/index.html', '_blank');
  };
  return {
    loginType,
    qrCodeUrl,
    qrCodeStatus,
    qrCodeTime,
    maskTip,
    showMask,
    refreshLoading,
    getQrCode,
    goPage
  };
};
__sfc_main.components = Object.assign({
  VueQr
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 32px;
    font-size: 20px;
    font-weight: 700;
    color: #333333;
    text-align: center;
  }
  .code-area {
    display: flex;
    justify-content: center;
    .code-content {
      position: relative;
      width: 228px;
      height: 228px;
    }
    .code-mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.9);

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .code-mask-tip {
      margin-bottom: 25px;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
    }
    ::v-deep .el-button--success {
      height: 30px;
      background-color: #22c655;
      border-color: #22c655;
      border-radius: 4px;
    }

    ::v-deep .el-button--success:focus {
      background-color: #25de5e;
      border-color: #25de5e;
    }
    ::v-deep .el-button--success:hover {
      background-color: #23d25a;
      border-color: #23d25a;
    }
  }
  .tip {
    margin-top: 32px;
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;

    ::v-deep .el-button {
      font-size: 16px;
      font-weight: 500;
      color: #22c655;
    }
  }
</style>
